<template>
    <div class="">

        <Banner :background="(item.image) ? item.image : ''"
            :title="(!pgLoading) ? ($i18n.locale == 'en') ? item.en.title : item.ar.title : ''">
        </Banner>

        <div class="rules-area ptb-100">
            <div class="container">
                <p v-if="!pgLoading" v-html="($i18n.locale == 'en') ? item.en.body : item.ar.body"></p>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: 'List',
    components: {
        Banner: () => import('@/components/Banner.vue'),
    },
    data() {
        return {
            //
            item: '',
            refs: 'pages',
            pgLoading: true,
        }
    },
    mounted() { },
    created() {
        //
        this.fetchData();
    },
    methods: {
        //
        fetchData() {
            this.pgLoading = true;
            this.axios.defaults.headers.common = {
                'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
            };
            const options = {
                url: window.baseURL + '/pages/' + this.$route.params.slug,
                method: 'GET',
                data: {},
                headers: {
                    appId: process.env.VUE_APP_APPID
                }
            }
            this.axios(options)
                .then(res => {
                    this.pgLoading = false;
                    this.item = res.data.data.rows;
                })
                .catch(() => {
                    //
                })
                .finally(() => { });
        },
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
